export const fieldToValidateAdditionalService = [
  'AdditionalServicesName',
  'DestinationCountry',
  'AdditionalServiceType',
  'Description',
  'Margin',
];
